import MitigationCalulation from './components/pages/Mainpage';




function App() {
  return (
    <div className="App mitigation-app">
      <MitigationCalulation />
    </div>
  );
}

export default App;
